export class EndorsementsVarDataResponse {
    constructor(
      public lossOfEarnings: LossOfEarnings,
      public exPatSecurityEvac: ExPatSecurityEvac,
      public travelSecurityEvac: TravelSecurityEvac,
      public enhancedExPatSecurityEvac: EnhancedExPatSecurityEvac,
      public enhancedTravelSecurityEvac: EnhancedTravelSecurityEvac,
      public childAbduction: ChildAbduction,
      public enhancedChildAbduction: EnhancedChildAbduction,
      public workplaceViolence: WorkplaceViolence,
      public valueOfProducts: ValueOfProducts
    ) { }
}
export class LossOfEarnings{
  perInsuredEvent: PerInsuredEvent[];
  annualAggregate: AnnualAggregate[];
  indemnityPeriod: number;
  waitingPeriod: number;
}    
export class PerInsuredEvent{
  id:string;
  value:string;
}   
export class AnnualAggregate{
  id:string;
  value:string;
}   
export class ExPatSecurityEvac{
  perExpatSecurityEvac: PerExpatSecurityEvac[];
  annualAggregate: AnnualAggregate[];
  personalEffects: PersonalEffects[];
  salary: Salary;
  relocationCosts: RelocationCosts[];
  repatriationCosts: RepatriationCosts[];
  unityFeesExpenses: UnityFeesExpenses[];
  excludedCountries:ExcludedCountries[];
}  
export class PerExpatSecurityEvac{
  id:string;
  value:string;
} 
export class PersonalEffects{
  id:string;
  value:string;
}
export class Salary{
  id:string;
  value:string;
}
export class RelocationCosts{
  id:string;
  value:string;
}   
export class RepatriationCosts{
  id:string;
  value:string;
}
export class UnityFeesExpenses{
  id:string;
  value:string;
}
export class ExcludedCountries{
  id:string;
  value:string;
}
export class TravelSecurityEvac{
  perTravelSecurityEvac:PerTravelSecurityEvac[];
  annualAggregate: AnnualAggregate[];
  personalEffects:PersonalEffects[];
  repatriationCosts: RpatriationCosts[];
  unityFeesExpenses:UnityFeesExpenses[];
  excludedCountries: ExcludedCountries[];  
} 
export class PerTravelSecurityEvac{
  id:string;
  value:string;
} 
export class RpatriationCosts{
  id:string;
  value:string;
}
export class EnhancedExPatSecurityEvac{
  perExpatSecurityEvac:PerExpatSecurityEvac[];
  annualAggregate: AnnualAggregate[];
  personalEffects:PersonalEffects[];
  salary: Salary[];
  relocationCosts:RelocationCosts[];
  repatriationCosts: RepatriationCosts[];
  unityFeesExpenses:UnityFeesExpenses[];
  excludedCountries:ExcludedCountries[];
}    
export class EnhancedTravelSecurityEvac{
  perTravelSecurityEvac:PerTravelSecurityEvac[];
  annualAggregate: AnnualAggregate[];
  personalEffects:PersonalEffects[];
  repatriationCosts: RepatriationCosts[];
  unityFeesExpenses:UnityFeesExpenses[];
  excludedCountries: ExcludedCountries[];  
} 
export class ChildAbduction{
  perChildAbduction:PerChildAbduction[];
  annualAggregate: AnnualAggregate[];
}
export class PerChildAbduction{
  id:string;
  value:string;
}
export class EnhancedChildAbduction{
  perChildAbduction:PerChildAbduction[];
  annualAggregate: AnnualAggregate[];
  legalFees: LegalFees[];
}
export class LegalFees{
  id:string;
  value:string;
}
export class WorkplaceViolence{
  perWorkplaceViolence:PerWorkplaceViolence[];
  annualAggregate: AnnualAggregate[];
  maxBenefit: MaxBenefit[];
  aggPerWorkplaceViolence: AggPerWorkplaceViolence[];
  death: number;
  lossOfLimb: number;
  lossOfSight: number;
  lossOfSpeech: number;
  permTotalDisability: number;
  mutilation: number;
}
export class PerWorkplaceViolence{
  id:string;
  value:string;
}
export class MaxBenefit{
  id:string;
  value:string;
}
export class AggPerWorkplaceViolence{
  id:string;
  value:string;
}
export class ValueOfProducts{
  perInsuredEvent:PerInsuredEvent[];
  annualAggregate: AnnualAggregate[];
}
export class endorsementsVariablesDetails{
  quoteId?: string;   
  endorsements?: endorsements;  
}
export class endorsements{
  lossOfEarnings?: LossOfEarnings;
  exPatSecurityEvac?: ExPatSecurityEvac;
  travelSecurityEvac?: TravelSecurityEvac;
  enhancedExPatSecurityEvac?: EnhancedExPatSecurityEvac;
  enhancedTravelSecurityEvac?: EnhancedTravelSecurityEvac;
  childAbduction?: ChildAbduction;
  enhancedChildAbduction?: EnhancedChildAbduction;
  workplaceViolence?: WorkplaceViolence;
  amendedAssetThreshold: amendedAssetThreshold;
  valueOfProducts?: ValueOfProducts;
}
export class amendedAssetThreshold{
  percentage: number;
}
    